import React from "react";

import { FaPlay } from "react-icons/fa";

import { Form } from "react-bootstrap";
// Sample UserInfo component
const UserInfo = ({ user, statelist, citylist ,countrylist}) => {

  return (


    <div className="tab-box-section mt-3">
      <Form noValidate
        // validated={validated}
        style={{ pointerEvents: 'none' }}
      >
        <div className="tab-form-header mb-3">
          <h3>Your Info</h3>
        </div>
        <div className="row gx-2">
          <div className="col-md-12 form-group" controlid="validationCustom01">
            <input type="text" name="firstname"
              className="form-control dashboard-input-box-3" placeholder="First name" required value={user.firstname} />
            <Form.Control.Feedback type="invalid">
              Please enter a first name.
            </Form.Control.Feedback>
          </div>
          <div className="col-md-12 form-group" controlid="validationCustom02">
            <input type="text"
              name="lastname"
              className="form-control dashboard-input-box-3" placeholder="Last name" required value={user.lastname} />
            <Form.Control.Feedback type="invalid">
              Please enter a last name.
            </Form.Control.Feedback>
          </div>
          <div className="col-6 col-md-6 form-group" controlid="validationCustom01">
            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={true} value={user.height_ft} aria-label="Default select example">
              <option value={0}>ft.</option>
              <option value="4">4 ft.</option>
              <option value="5">5 ft.</option>
              <option value="6">6 ft.</option>
              <option value="7">7 ft.</option>
            </select>


          </div>
          <div className="col-6 col-md-6 form-group" controlid="validationCustom01">

            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" disabled={true} value={user.height_in} aria-label="Default select example">
              <option value={0}>in.</option>
              <option value="1">0 in.</option>
              <option value="2">1 in.</option>
              <option value="3">2 in.</option>
              <option value="4">3 in.</option>
              <option value="5">4 in.</option>
              <option value="6">5 in.</option>
              <option value="7">6 in.</option>
              <option value="8">7 in.</option>
              <option value="9">8 in.</option>
              <option value="10">9 in.</option>
              <option value="11">10 in.</option>
              <option value="12">11 in.</option>
            </select>
          </div>
          <div className="col-12 col-md-12 form-group" controlid="validationCustom01">


            <input
              type="text"
              name={"dexterity"}
              required
              disabled={true}
              className={`form-select form-control dashboard-input-box-3 select-custom-boxx`}
              value={user.dexterity == 1 ? "Right Handed" : "Left Handed"}
            />

          </div>
          <div className="col-md-12 form-group" controlid="validationCustom03">
            <input name="phone" type="tel" value={user.phone} pattern="[0-9]{8,}" title="Please enter a 8-digit phone number." className="form-control dashboard-input-box-3" placeholder="Phone" required />
            <Form.Control.Feedback type="invalid">
              Please enter a 8-digit phone number.
            </Form.Control.Feedback>
          </div>
          <div className="col-md-12 form-group" controlid="validationCustom04">
            <input name="email" type="email" value={user.email} className="form-control dashboard-input-box-3" placeholder="Email" required />
            <Form.Control.Feedback type="invalid">
              Please choose a email.
            </Form.Control.Feedback>
          </div>
          <div className="col-md-12 form-group" controlid="validationCustom04">
            <input name="address" type="text" value={user.address} className="form-control dashboard-input-box-3" placeholder="Street Address, Apt. #" required />
            <Form.Control.Feedback type="invalid">
              Please choose a street address.
            </Form.Control.Feedback>
          </div>
          <div className="col-md-12 form-group" controlid="validationCustom01">
            {/* <input type="text" value={user.city} name="city" className="form-control dashboard-input-box-3" placeholder="City" required /> */}
            <select name="country" disabled value={user.country}
              class="form-select form-control dashboard-input-box-3 select-custom-boxx"
              aria-label="Default select example"
            >
              <option value={0}>Country</option>
              {countrylist &&
                countrylist.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name}
                  </option>
                ))}
            </select>
            <Form.Control.Feedback type="invalid">
              Please enter State
            </Form.Control.Feedback>
          </div>
          <div className="col-4 col-md-4 form-group mb-0" controlid="validationCustom01">
            {/* <input type="text" value={user.city} name="city" className="form-control dashboard-input-box-3" placeholder="City" required /> */}
            <select name="state" disabled value={user.state}
              class="form-select form-control dashboard-input-box-3 select-custom-boxx"
              aria-label="Default select example"
            >
              <option value={0}>State</option>
              {statelist &&
                statelist.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name}
                  </option>
                ))}
            </select>
            <Form.Control.Feedback type="invalid">
              Please enter State
            </Form.Control.Feedback>
          </div>
          <div className="col-4 col-md-4 form-group mb-0" controlid="validationCustom02">
            {/* <input type="text" value={user.state} name="state" className="form-control dashboard-input-box-3" placeholder="State" required /> */}
            <select name="city" disabled value={user.city}
              class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
              <option value={0}>City/Town</option>
              {citylist &&
                citylist.map((item) => (
                  <option value={item._id} key={item._id}>
                    {item.name}
                  </option>
                ))}
            </select>
            <Form.Control.Feedback type="invalid">
              Please enter State
            </Form.Control.Feedback>
          </div>
          <div className="col-4 col-md-4 form-group mb-0" controlid="validationCustom02">
            <input type="text" value={user.zip} name="zip" className="form-control dashboard-input-box-3" placeholder="Zip Code" required />
            <Form.Control.Feedback type="invalid">
              Please enter Zip Code
            </Form.Control.Feedback>
          </div>
        </div>
      </Form >
    </div >

  );
};

export default UserInfo;
